module.exports = __webpack_public_path__ + "static/media/bus-train-tram-svgrepo-com.35a1b4b6.svg";